import React, {
  createContext,
  useCallback,
  useEffect,
  useState,
  useRef,
} from 'react';
import ModalTrigger from './ModalTrigger';

const TriggerModalContext = createContext();

const inicialState = {
  isOpen: false,
  message: '',
  callback: () => null,
  tipo: 'success',
  Footer: null,
};

export const TriggerModalContextProvider = ({ children }) => {
  const providerRef = useRef(null);
  const [optionsModal, setOptionsModal] = useState(inicialState);

  const openModal = (
    message,
    callback = () => null,
    tipo = 'success',
    Footer = null
  ) => {
    setOptionsModal({
      ...inicialState,
      message,
      callback,
      tipo,
      Footer,
      isOpen: true,
    });
  };

  const closeModal = () => {
    setOptionsModal({ ...inicialState, isOpen: false });
  };

  const callbackEventShowModal = useCallback(({ detail }) => {
    const { options } = detail;
    openModal(options.message, options.callback, options.tipo, options.Footer);
  }, []);

  useEffect(() => {
    if (providerRef.current) {
      const event = document.createEvent('Event');

      event.initEvent('show-modal', true, true);
      providerRef.current.addEventListener(
        'show-modal',
        callbackEventShowModal,
        false
      );
    }
  }, [callbackEventShowModal]);

  return (
    <div ref={providerRef} id="show-modal-provider">
      <TriggerModalContext.Provider value={{ openModal }}>
        {children}
        {optionsModal.isOpen && (
          <ModalTrigger {...optionsModal} closeModal={closeModal} />
        )}
      </TriggerModalContext.Provider>{' '}
    </div>
  );
};
